import { OmapiIdsUtils } from '../shared/utils/omapi-ids/omapi-ids-utils';
import { TvShopEntertainmentPackGroupIds } from '../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';
var StreamingServicesUtil = /** @class */ (function () {
    function StreamingServicesUtil() {
    }
    StreamingServicesUtil.getStandAloneStreamingServices = function (streamingServices) {
        var streamingStandalone = streamingServices.filter(function (streamingService) {
            return streamingService.isStreamingStandaloneProduct;
        });
        if (streamingStandalone) {
            return streamingStandalone;
        }
        return [];
    };
    StreamingServicesUtil.getStreamingBundles = function (streamingServices) {
        var streamingBundles = streamingServices.filter(function (streamingService) {
            return streamingService.isStreamingBundle;
        });
        if (streamingBundles) {
            return streamingBundles.sort(function (a, b) { return a.omapiId > b.omapiId ? 1 : -1; });
        }
        return [];
    };
    StreamingServicesUtil.getStandAloneNetflix = function (streamingServices) {
        return streamingServices.find(function (ss) { return ss.omapiId === OmapiIdsUtils.NETFLIX_BASIC_ID; });
    };
    StreamingServicesUtil.getStandAloneDisneyPlus = function (streamingServices) {
        return streamingServices.find(function (ss) { return ss.omapiId === OmapiIdsUtils.DISNEY_PLUS_ID; });
    };
    StreamingServicesUtil.getNetflixStandaloneGroup = function (streamingServices) {
        return streamingServices.find(function (ss) { return ss.omapiId === TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE; });
    };
    return StreamingServicesUtil;
}());
export { StreamingServicesUtil };
